import reactUpdate from 'immutability-helper';
import * as PropTypes from 'prop-types';
import React from 'react';

import {InaccessibleInfo} from 'auth/RequestAccess';
import * as EventConstants from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import notifications, {GenericResponseJSON, Response} from 'notifications';

export function isUnreadableSampleError(response: Response): boolean {
  const responseJSON = response.responseJSON || response;
  return Boolean((responseJSON as GenericResponseJSON).unreadableSampleId);
}

export function dispatchUnreadableSampleError(storableId: string, response: Response): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.STORABLE_FETCH_FAILED_WITH_UNREADABLE_SAMPLE_ERROR,
    errorMessage: notifications.getFriendlyError(response),
    storableId,
  });
}

export function dispatchInaccessibleError(storableId: string, response: Response): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.STORABLE_FETCH_FAILED_WITH_INACCESSIBLE_ERROR,
    info: response.responseJSON,
    storableId,
  });
}

export interface StorableAuthState {
  errorMessages: {
    [storableId: string]: string;
  };
  inaccessibleInfos: {
    [storableId: string]: InaccessibleInfo | null;
  };
}

/**
 * Store auth error messages by storable
 */
export const SubStore = {
  getInitialState(): StorableAuthState {
    return {errorMessages: {}, inaccessibleInfos: {}};
  },

  handleAction(state: StorableAuthState, action: FluxAction): StorableAuthState {
    switch (action.actionType) {
      case EventConstants.STORABLE_FETCH_FAILED_WITH_UNREADABLE_SAMPLE_ERROR:
        return reactUpdate(state, {errorMessages: {$merge: {[action.storableId]: action.errorMessage}}});
      case EventConstants.STORABLE_FETCH_FAILED_WITH_INACCESSIBLE_ERROR:
        return reactUpdate(state, {inaccessibleInfos: {$merge: {[action.storableId]: action.info}}});
      default:
        return state;
    }
  },

  getErrorMessage(state: StorableAuthState, storableId: string): string {
    return state.errorMessages[storableId];
  },

  getInaccessibleInfo(state: StorableAuthState, storableId: string): InaccessibleInfo | null {
    return state.inaccessibleInfos[storableId] || null;
  },
};

/**
 * Render auth error message in a banner
 */
function ErrorBanner(props: ErrorBannerPropTypes): JSX.Element {
  return <div className="alert alert-danger u-spacing">{props.message}</div>;
}
export interface ErrorBannerPropTypes {
  message: string;
}
ErrorBanner.propTypes = {
  message: PropTypes.string.isRequired,
};
export {ErrorBanner};
